var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.72 4.72a.75.75 0 011.06 0L10 8.94l4.22-4.22a.75.75 0 111.06 1.06L11.06 10l4.22 4.22a.75.75 0 11-1.06 1.06L10 11.06l-4.22 4.22a.75.75 0 01-1.06-1.06L8.94 10 4.72 5.78a.75.75 0 010-1.06z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im00LjcxOTY3IDQuNzE5NjdjLjI5Mjg5LS4yOTI4OS43Njc3Ny0uMjkyODkgMS4wNjA2NiAwbDQuMjE5NjcgNC4yMTk2NyA0LjIxOTctNC4yMTk2N2MuMjkyOS0uMjkyODkuNzY3Ny0uMjkyODkgMS4wNjA2IDBzLjI5MjkuNzY3NzcgMCAxLjA2MDY2bC00LjIxOTYgNC4yMTk2NyA0LjIxOTYgNC4yMTk3Yy4yOTI5LjI5MjkuMjkyOS43Njc3IDAgMS4wNjA2cy0uNzY3Ny4yOTI5LTEuMDYwNiAwbC00LjIxOTctNC4yMTk2LTQuMjE5NjcgNC4yMTk2Yy0uMjkyODkuMjkyOS0uNzY3NzcuMjkyOS0xLjA2MDY2IDBzLS4yOTI4OS0uNzY3NyAwLTEuMDYwNmw0LjIxOTY3LTQuMjE5Ny00LjIxOTY3LTQuMjE5NjdjLS4yOTI4OS0uMjkyODktLjI5Mjg5LS43Njc3NyAwLTEuMDYwNjZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPgo=";
export { SvgCancel20 as ReactComponent };